import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ExtraPages.css';

const AboutPage = () => {
  return (
    <main className="extra-page-shell">
      <section className="extra-page-hero">
        <p className="extra-kicker">About EntrepreLearn</p>
        <h1>We make entrepreneurship practical, playful, and beginner-friendly.</h1>
        <p>
          EntrepreLearn helps students and first-time founders build real-world business confidence through
          short lessons and games that feel rewarding from day one.
        </p>
      </section>

      <section className="extra-grid">
        <article>
          <h2>Our Mission</h2>
          <p>
            Turn entrepreneurship education into an active habit by combining quick theory with hands-on
            decisions, feedback, and repetition.
          </p>
        </article>
        <article>
          <h2>Our Learning Style</h2>
          <p>
            Learn a concept, test it immediately, and improve through challenge loops. Each loop is designed
            to sharpen strategic thinking and confidence.
          </p>
        </article>
      </section>

      <div className="extra-actions">
        <Link to="/modules" className="extra-btn solid">Explore Modules</Link>
        <Link to="/games" className="extra-btn light">Play Games</Link>
      </div>
    </main>
  );
};

export default AboutPage;
